module.exports = __webpack_public_path__ + "img/Boy_030020.28d09c70.png";